<template>
  <div v-if="detail">
    <!-- HERO -->
    <section class="hero-hero d-flex align-items-center justify-content-center" data-aos="fade-up" data-aos-duration="1200">
      <div
        class="hero-bg-img"
        :style="`background-image:url('${detail.hero && detail.hero.image ? detail.hero.image : ''}')`"
      ></div>

      <!-- Capa de gradiente -->
      <div class="hero-overlay"></div>

      <!-- Breadcrumb en overlay -->
      <nav
        class="hero-crumbs"
        role="navigation"
        aria-label="breadcrumbs"
      >
        <router-link
          class="crumb-link"
          to="/servicios"
          aria-label="Volver a Servicios"
          :title="crumbServiciosLabel"
        >
          <svg class="crumb-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path fill="currentColor" d="M9.78 3.22a.75.75 0 0 1 0 1.06L6.06 8l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0z"/>
          </svg>
          <span class="crumb-text">{{ crumbServiciosLabel }}</span>
        </router-link>
        <span class="crumb-sep" aria-hidden="true">/</span>
        <span class="crumb-current" aria-current="page">{{ detail.hero.title }}</span>
      </nav>

      <!-- Contenido del hero -->
      <div class="hero-hero-content text-center text-white">
        <h1 class="display-5 fw-bold hero-hero-title">{{ detail.hero.title }}</h1>
        <p class="lead hero-hero-lead">{{ tab.title }}</p>
      </div>
    </section>

    <div class="container-xxl px-1 px-sm-3 pt-4 pb-1">
      <div class="row gx-lg-5">
        <!-- SIDEBAR DESKTOP -->
        <nav class="col-lg-2 d-none d-lg-flex flex-column align-items-end sticky-top" style="top:95px;z-index:20;" data-aos="zoom-in" data-aos-duration="6000"> 
          <ul class="sidebar-nav">
            <li v-for="item in tab.index" :key="item.anchor">
              <a :href="'#'+item.anchor" :class="['sidebar-link', {active: activeSection === item.anchor}]"
                @click="scrollToAnchor(item.anchor)">{{ item.label }}</a>
            </li>
          </ul>
        </nav>

        <!-- NAV HORIZONTAL MOBILE -->
        <div class="col-12 d-lg-none mb-3">
          <div class="mobile-nav px-2 py-1 d-flex flex-wrap gap-2 justify-content-center" data-aos="zoom-in" data-aos-duration="6000">
            <a
              v-for="item in tab.index"
              :key="item.anchor"
              :href="'#'+item.anchor"
              class="mobile-nav-link"
              :class="{active: activeSection === item.anchor}"
              @click="scrollToAnchor(item.anchor)"
            >{{ item.label }}</a>
          </div>
        </div>

        <!-- MAIN CONTENT -->
        <main class="col-lg-10 px-lg-4">
          <!-- INTRODUCCIÓN -->
          <section :id="tab.index[0].anchor" class="mb-4" data-aos="fade-up" data-aos-duration="6000">
            <div class="row align-items-center">
              <div class="col-md-5 text-center mb-2 mb-md-0" data-aos="fade-up" data-aos-duration="6000">
                <img
                  :src="tab && tab.image ? tab.image : ''"
                  :alt="detail.hero && detail.hero.title ? detail.hero.title : ''"
                  class="hero-img img-fluid shadow"
                />
              </div>
              <div class="col-md-7" data-aos="fade-up" data-aos-duration="6000">
                <h2 class="section-title pt-2 pb-1">{{ detail.hero.title }}</h2>
                <strong class="text-primary d-block mb-1" style="font-size:1.01rem;">{{ tab.index[0].label }}</strong>
                <p class="hero-intro-text" v-html="tab.introduccion.content"></p>
              </div>
            </div>
          </section>
          <hr />

          <!-- ¿Qué incluye el servicio? -->
          <section :id="tab.index[1].anchor" class="mb-5">
            <h3 class="section-title mb-2" data-aos="fade-up" data-aos-duration="6000">{{ tab.index[1].label }}</h3>
            <div class="row d-flex justify-content-end">
              <div class="col-lg-10">
                <div class="accordion shadow-sm" id="includesAccordion">
                  <div
                    data-aos="fade-up" data-aos-duration="6000"
                    class="accordion-item"
                    v-for="(item, i) in tab.incluye.items"
                    :key="'inc-' + i"
                  >
                    <h2 class="accordion-header" :id="'inc-heading'+i">
                      <button
                        class="accordion-button fw-bold"
                        type="button"
                        :class="{ collapsed: activeAccordion !== i }"
                        @click="activeAccordion = activeAccordion === i ? null : i"
                      >
                        {{ item.title }}
                      </button>
                    </h2>
                    <transition name="fade-slide" mode="out-in">
                      <div
                        :id="'inc-collapse'+i"
                        class="accordion-collapse collapse"
                        :class="{ show: activeAccordion === i }"
                        :aria-labelledby="'inc-heading'+i"
                        data-bs-parent="#includesAccordion"
                      >
                        <div class="accordion-body">
                          {{ item.content }}
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <hr />

          <!-- Ventajas del Servicio -->
          <section :id="tab.index[2].anchor" class="mb-5" data-aos="fade-up" data-aos-duration="6000">
            <div class="row align-items-start">
              <div class="col-md-4 pb-3 pb-md-0">
                <h3 class="section-title mb-0" data-aos="fade-up" data-aos-duration="6000">{{ tab.index[2].label }}</h3>
              </div>
              <div class="col-md-8">
                <ul class="advantages-list list-unstyled mt-2">
                  <li v-for="(item, i) in tab.ventajas.items" :key="'adv-' + i" data-aos="fade-up" data-aos-duration="6000">
                    <span class="check-icon">
                      <svg width="18" height="18" viewBox="0 0 18 18"><path fill="#3d7ecb" d="M7.4 14.3l-4.5-4.6 1.1-1.1 3.4 3.5 6.1-6.1 1.1 1.1z"/></svg>
                    </span>
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <hr />

          <!-- Banner Minimalista Black -->
          <section class="banner-minimal my-5 py-4" data-aos="fade-up" data-aos-duration="6000">
            <div class="container-fluid">
              <div class="row align-items-center justify-content-center">
                <div class="col-lg-8 col-md-7 py-2 px-3">
                  <div class="banner-minimal-title mb-2" data-aos="fade-up" data-aos-duration="6000">
                    {{ bannerTitle }}
                  </div>
                  <div class="banner-minimal-desc mb-3" v-html="bannerBody"></div>
                  <button
                    data-aos="fade-up" data-aos-duration="6000"
                    class="btn btn-light rounded-pill px-4 py-2 mt-1 shadow-sm banner-minimal-btn"
                    @click="goToWhatsApp"
                  >
                    ¡Hablemos!
                  </button>
                </div>
                <div class="col-lg-4 col-md-5 text-center d-none d-md-block">
                  <img
                    data-aos="fade-up" data-aos-duration="6000"
                    :src="bannerImageSrc"
                    :alt="bannerAlt"
                    class="banner-minimal-img img-fluid"
                    style="max-width:180px;"
                  />
                </div>
              </div>
            </div>
          </section>

          <hr />

          <!-- Para quién es este servicio -->
          <section :id="tab.index[3].anchor" class="mb-5" data-aos="fade-up" data-aos-duration="6000">
            <h3 class="section-title mb-4">{{ tab.index[3].label }}</h3>
            <div class="row g-3">
              <div
                data-aos="fade-up" data-aos-duration="6000"
                class="col-md-6 col-lg-4"
                v-for="(perfil, i) in tab.paraQuien.perfiles"
                :key="'perfil-' + i"
              >
                <div class="founder-card perfil-card shadow-sm h-100">
                  <template v-if="perfil.includes(':')">
                    <span class="perfil-strong" data-aos="fade-up" data-aos-duration="6000">{{ perfil.split(':')[0] }}:</span>
                    <span class="perfil-desc" data-aos="fade-up" data-aos-duration="6000">&nbsp;{{ perfil.split(':').slice(1).join(':') }}</span>
                  </template>
                  <template v-else>
                    <span class="perfil-desc" data-aos="fade-up" data-aos-duration="6000">{{ perfil }}</span>
                  </template>
                </div>
              </div>
            </div>
          </section>
          <hr />

          <!-- CTA -->
          <section class="cta-section text-center mt-3 mb-5" data-aos="fade-up" data-aos-duration="6000">
            <div class="cta-inner">
              <h4 class="cta-title fw-bold mb-2" data-aos="fade-up" data-aos-duration="6000">
                <i>{{ detail.cta.title }}</i>
              </h4>
              <div class="cta-content mb-3" data-aos="fade-up" data-aos-duration="6000">{{ detail.cta.content }}</div>
              <button
                data-aos="fade-up" data-aos-duration="6000"
                class="btn btn-sec btn-primary px-4 py-2"
                @click="goToContacto"
                style="border-radius: 25px; font-weight:600; font-size:1rem;">
                {{ detail.cta.button }}
              </button>
            </div>
          </section>
        </main>
      </div>
    </div>
    <!-- Footer -->
    <SiteFooter :selectedLang="selectedLang" />
  </div>
  <div v-else class="alert alert-danger m-5" style="font-family: 'JetBrains Mono', monospace">
    No se pudo cargar el contenido de Industria 4.0.<br />
    Verifica que la data esté bien estructurada e importada.
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import { servicios } from '@/assets/data/data.ts'
import SiteFooter from '@/components/SiteFooter.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'Industria4_0',
  components: {
    SiteFooter
  },
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  setup() {
    useSEO({
      title: 'Industria 4.0',
      description: 'Descubre cómo Frenkel Engineering integra SCADA, IoT, PLC, Grafana y analítica de datos para llevar tu planta industrial a la era de la Industria 4.0.',
      path: '/industria-4-0',
    });
  },
  data() {
    return {
      activeAccordion: 0,
      activeSection: "introduccion"
    }
  },
  computed: {
    detail() {
      if (
        servicios &&
        servicios['industria-4-0'] &&
        servicios['industria-4-0'].detail &&
        servicios['industria-4-0'].detail[this.selectedLang]
      ) {
        return servicios['industria-4-0'].detail[this.selectedLang];
      }
      // Fallback en español
      return servicios['industria-4-0']?.detail?.es || null;
    },
    tab() {
      if (
        this.detail &&
        this.detail.tabs &&
        Array.isArray(this.detail.tabs) &&
        this.detail.tabs.length > 0
      ) {
        return this.detail.tabs[0];
      }
      return {};
    },
    /* ---- Banner ---- */
    bannerTitle() {
      const raw = this.detail?.banner?.content || '';
      const lines = raw.split('\n').map(l => l.trim()).filter(Boolean);
      return lines[0] || '¿Tu empresa no encaja exactamente en estos perfiles?';
    },
    bannerBody() {
      const raw = this.detail?.banner?.content || '';
      const [, ...rest] = raw.split('\n');
      const safe = rest
        .map(line => line.trim())
        .filter(Boolean)
        .map(line => `<p>${this.escapeHtml(line)}</p>`)
        .join('');
      return safe;
    },
    bannerImageSrc() {
      return (this.detail && this.detail.banner && this.detail.banner.image)
        ? this.detail.banner.image
        : '';
    },
    bannerAlt() {
      return this.tab?.title || this.detail?.hero?.title || 'Banner';
    },
    /* ---- i18n para “Servicios” en crumbs ---- */
    crumbServiciosLabel() {
      const map = {
        es: 'Servicios',
        en: 'Services',
        de: 'Leistungen'
      };
      return map[this.selectedLang] || map.es;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScrollSpy)
    AOS.init({
      duration: 800,
      once: true
    });
    setTimeout(() => AOS.refresh(), 300);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScrollSpy)
  },
  methods: {
    scrollToAnchor(anchor) {
      const el = document.getElementById(anchor)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    onScrollSpy() {
      if (!this.tab.index) return;
      let found = this.tab.index[0].anchor;
      for (const section of this.tab.index) {
        const el = document.getElementById(section.anchor)
        if (el && window.scrollY + 130 >= el.offsetTop) found = section.anchor
      }
      this.activeSection = found
    },
    goToContacto() {
      this.$router.push({ path: '/contacto' })
    },
    goToWhatsApp() {
      const message = encodeURIComponent("Industria 4.0 – ¡Hola! Estoy interesado en soluciones para mi empresa 👋");
      const waUrl = `https://wa.me/525539960462?text=${message}`;
      window.open(waUrl, '_blank');
    },
    // Escape mínimo para insertar texto como HTML seguro en bannerBody
    escapeHtml(str) {
      return String(str)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;700&family=JetBrains+Mono:wght@400;700&display=swap');

.servicio-industria40 {
  font-family: 'Quicksand', 'JetBrains Mono', monospace;
  background: #fafcff;
  color: #1b2230;
  min-height: 100vh;
}

.hero-hero {
  height: 240px;
  min-height: 175px;
  position: relative;
  margin-bottom: 1.6rem;
}

/* Imagen de fondo */
.hero-bg-img {
  position: absolute;
  z-index: 1;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: brightness(0.67) blur(0.5px);
}

/* Overlay de gradiente */
.hero-overlay {
  position: absolute;
  z-index: 2;
  inset: 0;
  background: linear-gradient(90deg, #2a395fbb 20%, #4874bdcc 60%, #2a395faa 100%);
}

/* Breadcrumbs en overlay */
.hero-crumbs {
  position: absolute;
  z-index: 4;
  top: 12px;
  left: 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  line-height: 1;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.crumb-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: #ffffff;
  transition: opacity 0.2s ease;
}
.crumb-link:hover { opacity: 0.9; }

.crumb-icon { display: inline-block; }

.crumb-sep {
  opacity: 0.8;
  margin: 0 2px;
}

.crumb-current {
  opacity: 0.95;
  font-weight: 600;
}

/* Contenido del hero */
.hero-hero-content {
  z-index: 3;
  position: relative;
  width: 100%;
  padding-top: 0.8em;
}

.hero-hero-title {
  font-family: 'Quicksand', sans-serif;
  letter-spacing: 0.04em;
  font-size: 2.5rem;
  color: #fff;
  text-shadow: 0 3px 12px rgba(40,44,90,0.13);
}

.hero-hero-lead {
  font-family: 'Quicksand', sans-serif;
  font-size: 1.18rem;
  color: #ffb24c;
  margin-top: 0.1em;
  text-shadow: 0 2px 12px rgba(30,40,80,0.07);
}

@media (max-width: 767px) {
  .hero-hero { height: 120px; min-height: 70px; }
  .hero-hero-title { font-size: 1.37rem; }
  .hero-hero-lead { font-size: .95rem;}
  .hero-crumbs {
    top: 8px;
    left: 10px;
    padding: 5px 10px;
    font-size: 0.85rem;
    gap: 6px;
  }
}

/* Sidebar y otros estilos existentes */
.sidebar-nav {
  position: sticky;
  top: 105px;
  padding: 0;
  list-style: none;
}
.sidebar-link {
  display: block;
  font-weight: bold;
  color: #2c4366;
  margin-bottom: 0.3rem;
  font-size: 1.01rem;
  letter-spacing: 0.03em;
  border-left: 3px solid transparent;
  padding: 0.13rem 0.7rem 0.13rem 0.65rem;
  border-radius: 3px;
  transition: background 0.17s, border-color 0.2s;
}
.sidebar-link.active,
.sidebar-link:hover {
  background: #ecf2fe;
  color: #1565c0;
  border-left: 3px solid #3d7ecb;
}
.mobile-nav {
  background: #f3f5fb;
  border-radius: 9px;
  font-family: 'Quicksand', monospace;
  font-weight: 700;
}
.mobile-nav-link {
  padding: 0.4em 0.9em;
  color: #28568a;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 600;
  background: transparent;
  font-size: 1rem;
  transition: background .19s, color .13s;
}
.mobile-nav-link.active,
.mobile-nav-link:hover {
  background: #e2e9fa;
  color: #00336d;
}
.section-title {
  font-family: 'JetBrains Mono', monospace;
  font-size: 1.32rem;
  color: #28568a;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-bottom: 1.1rem;
}
.accordion-button {
  font-family: inherit;
  font-size: 1.04rem;
  font-weight: 700;
}
.accordion-body {
  font-size: 0.99rem;
  color: #38405a;
  line-height: 1.5;
}
.advantages-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.7em;
  margin-bottom: 0.7em;
  font-size: 0.99rem;
}
.check-icon {
  flex-shrink: 0;
  margin-top: 1px;
}
.perfil-card {
  background: #f9fbfe;
  border: 1.3px solid #e5eaf6;
  border-radius: 11px;
  padding: 1.07em 1.1em 1em 1.1em;
  min-height: 120px;
  font-size: 0.97rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: box-shadow 0.2s;
}
.perfil-card:hover {
  box-shadow: 0 3px 22px rgba(72,136,200,0.08);
}
.perfil-strong {
  font-family: 'JetBrains Mono', monospace;
  font-weight: 700;
  font-size: 1.06em;
  color: #244e8a;
}
.perfil-desc {
  font-family: 'Quicksand', monospace;
  font-weight: 400;
  color: #223;
  font-size: 1em;
  display: inline-block;
}
.banner-minimal {
  background: #141414;
  border-radius: 18px;
  border: 2px solid #1b1b1b;
  box-shadow: 0 2px 22px #2228;
  font-family: 'Quicksand', 'JetBrains Mono', monospace;
  color: #fff;
  letter-spacing: 0.04em;
  position: relative;
}
.banner-minimal-title {
  font-size: 1.49rem;
  color: #fff;
  font-family: 'JetBrains Mono', monospace;
  font-weight: bold;
  margin-bottom: 0.3em;
  line-height: 1.25;
}
.banner-minimal-desc {
  font-size: 1.01rem;
  color: #eaeaea;
  font-family: inherit;
  margin-bottom: 1rem;
  line-height: 1.45;
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.banner-minimal-btn {
  font-family: 'JetBrains Mono', monospace;
  border: 2px solid #fff;
  color: #181818;
  background: #fff;
  font-size: 1.09rem;
  font-weight: 700;
  transition: background .16s, color .13s, border .13s;
}
.banner-minimal-btn:hover {
  background: #ffb24c;
  color: #181818;
  border-color: #ffb24c;
}
.banner-minimal-img {
  border-radius: 12px;
  box-shadow: 0 2px 14px #0004;
  margin: 0 auto;
  background: #f4f4f4;
  border: none;
  object-fit: cover;
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.banner-minimal-img:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.btn-sec{
  background-color: #2c74b8;
}
.cta-section, .btn-sec{
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.cta-section:hover, .btn-sec:hover{
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
hr {
  border: none;
  border-top: 1.6px solid #0747d1;
  margin: 2.1rem 0 1.7rem 0;
}
.hero-img {
  border-radius: 12px;
  box-shadow: 0 6px 32px rgba(32,40,80,0.13);
  width: 95%;
  max-width: 350px;
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.hero-img:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.cta-section {
  background: #eef5fc;
  border-radius: 22px;
  max-width: 700px;
  margin: 0 auto;
  padding: 2.3rem 2.1rem 2.7rem 2.1rem;
  box-shadow: 0 3px 24px rgba(44,99,171,0.13);
  border: 2px solid #dbe9fa;
}
.cta-title {
  font-size: 1.35rem;
  color: #28568a;
  letter-spacing: 0.04em;
  font-family: 'JetBrains Mono', monospace;
}
.cta-content {
  font-family: 'Quicksand', sans-serif;
  color: #333;
  font-size: 1.06rem;
  margin-bottom: 0.5rem;
}
.hero-intro-text {
  font-size: 1.13rem;
  font-family: 'Quicksand', monospace;
  color: #2c2c2c;
  margin-bottom: 0.2em;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
}
.hero-intro-text::after{
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
}
.hero-intro-text:hover::after{
  width: 100%;
  opacity: .2;
}
.fade-title-enter-active, .fade-title-leave-active {
  transition: all 0.3s ease;
}
.fade-title-enter-from {
  opacity: 0;
  transform: translateY(-5px);
}
.fade-title-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.fade-title-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.fade-title-leave-to {
  opacity: 0;
  transform: translateY(5px);
}
.founder-card {
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.founder-card:hover {
  transform: scale(1.05);
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.8);
  cursor: pointer;
}
@media (max-width: 991px) {
  .sidebar-nav { display: none; }
  .hero-hero-title { font-size: 2rem; }
  .cta-section { padding: 1.1rem 0.7rem 1.5rem 0.7rem; }
}
@media (max-width: 767px) {
  .cta-section { padding: 0.5rem 0.3rem 1.2rem 0.3rem; }
  .banner-minimal-img { max-width: 110px; }
}
</style>
